import { Box, styled } from "@material-ui/core";
import GrayCheckCircle from "components/localOffer/assets/grayCheckCircle.svg";
import LowImpactPictoTurquoise from "components/localOffer/assets/lowImpactPictoTurquoise.svg";
import InformationDrawer from "components/design-system/molecules/InformationDrawer";
import LocalOfferDrawerContent from "components/localOffer/LocalOfferBlockDrawerContent";
import Body from "components/design-system/atoms/Typography/Body";
import H4 from "components/design-system/atoms/Typography/H4";
import theme from "theme";
import LocalOfferMobileModal from "components/design-system/organisms/LocalOfferMobileModal";
import Button from "components/design-system/atoms/Button";

const reinsuranceTexts = ["Click & collect gratuit", "Livraison 48h", "Soutient l'emploi local"];

const BackgroundBox = styled(Box)({
  backgroundImage: "url(/reconditionne/localOfferAssets/MobileGreen.svg)",
  backgroundRepeat: "round",
  margin: 0,
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(3),
  backgroundSize: "cover",
  color: theme.palette.secondary.main,
});

export default function LocalOfferBlockDefaultMobile({ addCatalogsToRefinementList }) {
  return (
    <BackgroundBox>
      <Box pb={2} pt={3} px={3}>
        <Box maxWidth={350} mb={2}>
          <Box mb={2}>
            <H4>Achetez local, c&apos;est l&apos;idéal</H4>
          </Box>
          {reinsuranceTexts.map((text, index) => (
            <Box display="flex" mb="4px" key={index}>
              <GrayCheckCircle />
              <Box ml={1}>
                <Body>{text}</Body>
              </Box>
            </Box>
          ))}
        </Box>
        <Box pt={4} pb={2} display="flex">
          <LowImpactPictoTurquoise />
          <Box pl={2}>
            <InformationDrawer
              anchor="bottom"
              width="100%"
              title="Disponibles près de chez vous"
              button={
                <Body color={"green"}>
                  <u>En savoir +</u>
                </Body>
              }
            >
              {() => <LocalOfferDrawerContent />}
            </InformationDrawer>
          </Box>
        </Box>
        <LocalOfferMobileModal addCatalogsToRefinementList={addCatalogsToRefinementList}>
          <Button version="green_and_light_green" fullWidth>
            Voir les produits régionaux
          </Button>
        </LocalOfferMobileModal>
      </Box>
    </BackgroundBox>
  );
}
